module.exports = __webpack_public_path__ + "img/texture_2.9b58327c.png";